<template>
  <div style="width: 100%;">
    <div
      class="cbs-dropdown"
      style="width: 100%;"
    >
      <div
        v-if="!isEdit"
        class="activator ref-picker-display"
        :style="getStyle()"
        @click="!doubleClick && setEditOn()"
        @dblclick="doubleClick && setEditOn()"
      >
        <span
          v-if="value === null"
          style="font-size: 0.8em; color: #b9b9c3; font-style: italic;"
        >
          NULL
        </span>
        <span v-else>
          {{ title || '\u00a0' }} <span
            v-if="value"
            style="font-size: 0.8em; color: #b9b9c3; margin-left: 3px;"
          >({{ value }})</span>
        </span>
      </div>

      <b-input-group
        v-if="isEdit"
        class="input-group-merge"
      >
        <b-form-input
          :id="`input_${uuid}`"
          v-model="work"
          :placeholder="title"
          @keydown="onKeyPress"
          @blur="input_blur"
          @keyup.stop
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="XIcon"
            class="cursor-pointer"
            @click="clearValue()"
            @mouseover="isMouseOnX = true"
            @mouseout="isMouseOnX = false"
          />
        </b-input-group-append>
      </b-input-group>

      <ul
        v-if="menuVisible"
        :id="`menu_${uuid}`"
        class="cbs-dropdown-menu"
        @click="menu_click()"
        @keydown="onKeyPress"
        @mouseover="isMouseOnMenu = true"
        @mouseout="isMouseOnMenu = false"
      >
        <li
          v-if="loading"
          style="padding: 0.5rem; text-align: center; color: #999;"
        >
          <b-spinner
            small
            style="margin-right: 0.3rem;"
          />
          {{ t('Loading') }}
        </li>
        <li
          v-for="el in options()"
          :key="el.value"
          style="padding: 0; border-bottom: solid #eeeeee 1px;"
        >
          <div
            v-if="el.disabled"
            class="bg-secondary bg-lighten-5"
            style="padding: 0.5rem;"
          >
            {{ el.title }}
          </div>
          <div
            v-else-if="checkValue(field, el)"
            class="bg-primary bg-lighten-5 selectable"
            style="padding: 0.5rem;"
            :data-value="JSON.stringify({ value: el.value, title: el.title })"
          >
            {{ el.title && el.title !== '' ? el.title : `(${el.value})` }}
          </div>
          <div
            v-else
            class="selectable"
            :data-value="JSON.stringify({ value: el.value, title: el.title })"
            style="cursor: pointer; padding: 0.5rem;"
            @click="selectElement(el)"
          >
            {{ el.title }}
          </div>
        </li>
      </ul>

      <div v-if="false">
        title: {{ title }}
      </div>
    </div>
    <cbs-debug
      v-if="false && isRoot"
      :context="this"
    />
  </div>
</template>

<script>
import CbsDebug from '@/cubus/components/debug/CbsDebug.vue'
import {
  BFormInput, BInputGroup, BInputGroupAppend, BSpinner,
} from 'bootstrap-vue'
import useCubus from '@/cubus/services/useCubus'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import nextCell from '@/@core/utils/next-cell'
import { scrollIntoViewIfNeeded } from '@/@core/utils/utils'

export default {
  name: 'CbsReferencePicker3',
  components: {
    CbsDebug,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BSpinner,
  },
  props: {
    field: {
      type: Object,
      default: null,
    },
    variant: {
      type: String,
      default: '',
    },
    record: {
      type: Object,
      default: null,
    },
    propRef: {
      type: Array,
      default: null,
    },
    noRefresh: {
      type: Boolean,
      default: false,
    },
    noLink: {
      type: Boolean,
      default: false,
    },
    keyMode: {
      type: String,
      default: 'key',
    },
    align: {
      type: String,
      default: 'left',
    },
    doubleClick: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['updateCell', 'refLoaded'],
  data() {
    return {
      menuVisible: false,
      title: null,
      value: null,
      isEdit: false,
      work: null,
      uuid: null,
      isMouseOnMenu: false,
      isMouseOnX: false,
      ref: null,
      loading: false,
    }
  },
  setup() {
    const { t } = useI18nUtils()
    return {
      t,
      isRoot: useCubus.isRoot(),
    }
  },
  watch: {
    record: {
      handler() {
        this.init()
      },
      deep: true,
    },
  },
  created() {
    this.uuid = useCubus.guid()
    this.init()
    if (typeof window !== 'undefined') {
      window.addEventListener('mousedown', this.onGlobalClick, true)
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('mousedown', this.onGlobalClick, true)
    }
  },
  methods: {
    init() {
      this.title = this.keyMode === 'sid' ? this.record[this.field.entitysid].title : this.record[this.field.key].title
      this.value = this.keyMode === 'sid' ? this.record[this.field.entitysid].value : this.record[this.field.key].value
    },
    checkMenuVisible() {
      setTimeout(() => {
        const el = this.currentSelectedMenuItem()
        if (el) {
          scrollIntoViewIfNeeded(el)
        }
      }, 100)
    },
    currentSelectedMenuItem() {
      const el = document.getElementById(`menu_${this.uuid}`)
      if (!el) return null
      return el.querySelector('.bg-primary')
    },
    onKeyPress(event) {
      if (event.key === 'Backspace' || event.key === 'Delete') {
        return
      }
      if (event.key === 'Enter') {
        const el = event.target
        const table = el && el.closest('table')
        const nextCellNoActivate = table.classList.contains('next-cell-no-activate')
        if (!nextCellNoActivate) {
          this.menuVisible = false
          this.isEdit = false
        }
        let selected = this.currentSelectedMenuItem()
        if (!selected) {
          const menu = document.getElementById(`menu_${this.uuid}`)
          if (menu) selected = menu.querySelector('.selectable')
        }
        if (selected) {
          const selectedData = JSON.parse(selected.getAttribute('data-value'))
          this.$emit('updateCell', selectedData)
        }
      }
      if (['Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
        if (nextCell(false, event)) {
          this.menuVisible = false
          this.isEdit = false
          this.checkMenuVisible()
        }
      }
      if (event.key === 'Escape') {
        event.preventDefault()
        this.menuVisible = false
        this.isEdit = false
        this.work = null
        this.isMouseOnX = false
        this.isMouseOnMenu = false
        const inputEl = document.getElementById(`input_${this.uuid}`)
        if (inputEl) {
          inputEl.blur()
        }
        this.checkMenuVisible()
      }
      if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        let direction = 1
        if (event.key === 'ArrowUp') direction = -1
        console.log('Trying up')
        const selected = this.currentSelectedMenuItem()
        if (selected) {
          const li = selected.parentElement
          let nextMenuItem
          if (direction === 1) {
            nextMenuItem = li.nextElementSibling.querySelector('div')
          } else {
            nextMenuItem = li.previousElementSibling.querySelector('div')
          }
          if (nextMenuItem) {
            if (nextMenuItem.classList.contains('bg-secondary')) {
              if (direction === 1) {
                nextMenuItem = nextMenuItem.parentElement.nextElementSibling.querySelector('div')
              } else {
                nextMenuItem = nextMenuItem.parentElement.previousElementSibling.querySelector('div')
              }
              if (!nextMenuItem) return
              if (nextMenuItem.classList.contains('bg-secondary')) {
                return
              }
            }
            selected.classList.remove('bg-primary', 'bg-lighten-5')
            nextMenuItem.classList.add('bg-primary', 'bg-lighten-5')
            scrollIntoViewIfNeeded(nextMenuItem)
          }
        } else {
          const menu = document.getElementById(`menu_${this.uuid}`)
          console.log('menu', menu)
          const firstMenuItem = menu.querySelector('.selectable')
          console.log('firstMenuItem1', firstMenuItem)
          if (firstMenuItem) {
            firstMenuItem.classList.add('bg-primary', 'bg-lighten-5')
            scrollIntoViewIfNeeded(firstMenuItem)
          }
        }
      }
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible
      this.work = this.title
      this.isEdit = true
      this.checkMenuVisible()
    },
    onBlur() {
      this.menuVisible = false
      this.isEdit = false
      console.log('setEditOff', this)
      this.checkMenuVisible()
    },
    selectElement(el) {
      this.menuVisible = false
      this.isEdit = false
      this.isMouseOnX = false
      this.isMouseOnMenu = false
      this.$emit('updateCell', el)
      this.checkMenuVisible()
    },
    onFocus() {
      // console.log('onfocus')
      this.menuVisible = true
      this.checkMenuVisible()
    },
    editOn() {
      this.setEditOn()
    },
    setEditOn() {
      if (this.record.cbs_access === 'ro') return
      if (this.record.cbs_sys_access === 'ro') return
      if (!this.propRef && !this.ref) this.loadRef()
      this.menuVisible = true
      this.isEdit = true
      this.$nextTick(() => {
        document.getElementById(`input_${this.uuid}`).focus()
      })
      this.checkMenuVisible()
    },
    setEditOff() {
      this.isEdit = false
      console.log('setEditOff', this)
    },
    onGlobalClick(e) {
      // если меню открыто и кликнули НЕ внутри компонента
      if (this.menuVisible && this.$el && !this.$el.contains(e.target)) {
        this.closeMenu()
      }
    },
    closeMenu() {
      this.menuVisible = false
      this.isEdit = false
      this.work = null
      this.isMouseOnX = false
      this.isMouseOnMenu = false
    },
    menu_click() {
      // console.log('menu_click')
    },
    input_blur(event) {
      // console.log('input_blur')
      // console.log('event', $event)
      // this.menuVisible = false
      if (this.isMouseOnX) {
        this.clearValue()
      } else if (this.isMouseOnMenu) {
        // console.log('Mouse is On Menu')
      } else {
        this.isEdit = false
        this.menuVisible = false
        this.work = null
      }
      this.checkMenuVisible()
    },
    options() {
      const data = this.propRef || this.ref
      if (!data) return []
      if (this.work) return data.filter(el => this.filterBy(el.title, this.work))
      return data
    },
    filterBy(title, search) {
      const pattern = `^${search
        .replace(new RegExp(' ', 'gi'), '.*')
        .replace(new RegExp('\\.\\*\\.\\*', 'gi'), ' ')}.*`
      const re = new RegExp(pattern, 'gi')
      return re.test(title || '')
    },
    clearValue() {
      this.title = null
      this.value = null
      this.isEdit = false
      this.menuVisible = false
      this.isMouseOnX = false
      this.isMouseOnMenu = false
      this.$emit('updateCell', { value: null, title: null })
      this.checkMenuVisible()
    },
    async loadRef() {
      this.loading = true
      const ref = await useCubus.loadRef(this, { entityid: this.field.entityid })
      this.loading = false
      if (ref) {
        // Mark folder records as disabled — keeps them visible in the list (greyed out)
        // but prevents selection. Backend now returns `isfolder` flag in toRef payload.
        this.ref = ref.map(el => (el.isfolder ? { ...el, disabled: true } : el))
        this.$emit('refLoaded', { entityid: this.field.entityid, refobjectid: this.field.refobjectid, ref: this.ref })
      }
    },
    checkValue(field, el) {
      if (this.keyMode === 'sid') {
        return this.record[field.entitysid].value === el.value
      }
      return this.record[field.key].value === el.value
    },
    getStyle() {
      const res = { textAlign: this.align }
      if (this.record.cbs_access === 'rw') res.cursor = 'pointer'
      return res
    },
  },
}
</script>

<style scoped>
.cbs-dropdown {
  position: relative;
  display: inline-block;
}

.ref-picker-display {
  border: none;
  padding: 0;
  min-height: 1.2em;
}

.cbs-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #dee2e6;
  border-radius: 4px;
  list-style: none;
  padding: 0;
  margin: 2px 0 0 0;
  width: 200%;
  min-width: 200px;
  z-index: 200;
  overflow-y: auto;
  max-height: 30vh;
}

.cbs-dropdown-menu li {
  padding: 0;
  text-align: left;
}

.cbs-dropdown-menu li:hover {
  background-color: #f8f9fa;
}

.cbs-dropdown-menu li:last-child {
  border-bottom: none !important;
}

.selectable {
  transition: background-color 0.15s ease;
}

.selectable:hover {
  background-color: #e9ecef !important;
}
</style>
